export default __webpack_public_path__ + "img/invoice-icon-active.c2bcc6e5.svg";